import React from 'react';
import { debounce } from 'lodash-es';
import AsyncSelect from 'react-select/async';
import { faMoneyBillWave } from '@fortawesome/free-solid-svg-icons';
import { httpClient } from '@s20/services/httpClient';
import { NumericInput } from '../common/forms/FormElements';
import CommonContext, { ApiRoutes } from '../Common';
import { DatePicker } from '../common/forms/DatePicker';
import ValidatedSelect from '../common/forms/ValidatedSelect';
import SlideForm from '../common/forms/SlideForm';

export class EmployeeCountyIncentiveForm extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.state = {
            formValidated: false,
            errors: {},
        };
        this.onSubmit = this.onSubmit.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    componentDidMount() {
        return this.populateState();
    }

    loadOptions = debounce((searchString, callback) => {
        httpClient.post(ApiRoutes.USCounties.all(), { searchString })
            .then((data) => callback(data.map((option) => ({ id: option.id, name: `${option.name} (${option.usState.name})` }))));
    }, 250);

    onClose(response) {
        this.resetForm(); // Reset the form
        this.context.setFormOpened(false);
        this.props.onClose(response);
    }

    resetForm = () => {
        this.setState({
            formValidated: false,
            errors: {},
            validationMessage: null,
        });
    };

    onSubmit = async () => {
        const { onSaveCallback } = this.props;
        await onSaveCallback();
    };

    populateState = () => this.setState({ loading: false });

    render() {
        const {
            show, countyIncentive, isValidated, setIsValidated, onChange, onCountyChange, onRemoveIncentive,
        } = this.props;
        const { errors, validationMessage } = this.state;

        if (!countyIncentive) {
            return '';
        }

        return (
            <SlideForm
                loading={this.state.loading}
                show={show}
                id="countyIncentiveForm"
                formIcon={faMoneyBillWave}
                formTitle={countyIncentive.id ? 'Edit County Incentive' : 'New County Incentive'}
                ref={this.formRef}
                setIsValidated={setIsValidated}
                isValidated={isValidated}
                onSubmit={this.onSubmit}
                onClose={this.onClose}
                errors={errors}
                error={validationMessage}
                entityId={countyIncentive.id}
                onDelete={onRemoveIncentive}
            >
                <ValidatedSelect
                    id="countyId"
                    name="countyId"
                    label="County"
                    component={AsyncSelect}
                    loadOptions={this.loadOptions}
                    value={countyIncentive.countyId ? { id: countyIncentive.countyId, name: countyIncentive.countyName } : null}
                    getOptionLabel={(option) => option?.name}
                    getOptionValue={(option) => ({ id: option?.id, name: `${option?.name} (${option?.usState?.name})` })}
                    onChange={onCountyChange}
                    placeholder="Start typing a county…"
                    noOptionsMessage={() => 'Start typing a county…'}
                    required
                    error="A County selection is required."
                />
                <NumericInput
                    label="Incentive Amount"
                    id="incentiveAmount"
                    name="incentiveAmount"
                    value={countyIncentive.incentiveAmount}
                    onChange={onChange}
                    placeholder="Enter Incentive Amount"
                    type="number"
                    step="any"
                    error="Incentive Amount is required."
                    required
                />
                <DatePicker
                    id="startDate"
                    label="Start Date"
                    name="startDate"
                    selectsStart
                    selected={countyIncentive.startDate ? new Date(countyIncentive.startDate) : null}
                    startDate={countyIncentive.startDate}
                    endDate={countyIncentive.endDate}
                    onChange={onChange}
                    showTimeInput={false}
                    required
                    error="Start Date is required."
                />
                <DatePicker
                    id="endDate"
                    name="endDate"
                    label="End Date"
                    selectsEnd
                    selected={countyIncentive.endDate ? new Date(countyIncentive.endDate) : null}
                    startDate={countyIncentive.startDate}
                    endDate={countyIncentive.endDate}
                    minDate={countyIncentive.startDate}
                    onChange={onChange}
                    showTimeInput={false}
                />
            </SlideForm>
        );
    }
}
